import React from 'react';
import JSNotification from './jsNotification';

export default class Notifications extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    async componentDidMount() {
        const notif = new JSNotification(
            'divNotifications_status',
            'btnNotifications_toggleSubscribed',
            'divNotifications_subscription',
            this.props.jurorID
        );
    }

    // eslint-disable-next-line no-unused-vars
    updateResponse(id, resp) {}
    // this seems like boiler-plate code that could be useful in the future

    render() {
        return (
            <div style={{ display: this.props.visible === 'true' ? 'block' : 'none' }}>
                <hr />
                <div style={{ margin: '0 5% 0 5%', fontWeight: 'bold' }}>Notifications</div>
                <div id="divNotifications_status" style={{ margin: '0 5% 0 5%' }}>
                    notifications status...
                </div>
                <div id="divNotifications_subscription" style={{ margin: '0 5% 0 5%', display: 'none' }}>
                    subscription...
                </div>
                <div style={{ margin: '0 5% 0 5%', display: 'block' }}>
                    <button id="btnNotifications_toggleSubscribed">Subscribe</button>
                </div>
                <hr />
            </div>
        );
    }
}
